export enum FormInputNameCreditCard {
  number = 'number',
  month = 'month',
  year = 'year',
  cvv = 'cvv',
  name = 'name',
  document = 'document',
}
